module.exports = __webpack_public_path__ + "img/table.ee9d4a97.png";